/**
 * Range helpers for the catalog bridge.
 *
 * The catalog publishes bands (`{ min, max }`) because crop year and pitch rate
 * move every published figure; a recipe is brewed with one number. The
 * mid-point is the honest default and the recipe item is then editable, which
 * is the whole design: the catalog states what is known, the recipe states what
 * is in the bag.
 */

/** An inclusive band, matching the catalog's `Range`. */
export interface NumericRange {
  readonly min: number;
  readonly max: number;
}

/** The arithmetic mid-point of a band. */
export function midpoint(range: NumericRange): number {
  return (range.min + range.max) / 2;
}

/** {@link midpoint}, passing `null` through for the fields the catalog leaves unpublished. */
export function midpointOf(range: NumericRange | null): number | null {
  return range === null ? null : midpoint(range);
}
